import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../componentes/header/header";
import homeData from "./traducao.json";
import FinalComponent from "../../../componentes/EndPage/Final";
import fundoSobreNos from './FundoSobrenos.png';

const SobreNos = () => {
    const [language, setLanguage] = useState(localStorage.getItem("siteLanguage") || "pt");
    const [translation, setTranslation] = useState(homeData[localStorage.getItem("siteLanguage") || "pt"]);

    useEffect(() => {
        const savedLang = localStorage.getItem("siteLanguage");
        const browserLanguage = navigator.language.split("-")[0];
        const newLang = savedLang || (homeData[browserLanguage] ? browserLanguage : "pt");
        setLanguage(newLang);
        setTranslation(homeData[newLang] || homeData["pt"]);

        const handleStorage = (e) => {
            if (e.key === "siteLanguage") {
                const updatedLang = e.newValue || "pt";
                setLanguage(updatedLang);
                setTranslation(homeData[updatedLang] || homeData["pt"]);
            }
        };
        window.addEventListener("storage", handleStorage);
        return () => window.removeEventListener("storage", handleStorage);
    }, []);

    return (
        <div>

           {/*
            <div style={{
                backgroundImage: `url(${fundoSobreNos})`,
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                zIndex: -5
                    }
                }>
            </div>
            */}


       

                <Helmet>
                <title>{translation.page_title || "Sobre Nós | SobreVidas-ACS"}</title>
            </Helmet>
            <Header/>   

            <div className="flex justify-center w-full">
                <h2
                    className="
                        text-[30px] text-[#B040B1] font-black relative inline-block
                        mt-[0vh] mb-[6vh]
                        max-[1424px]:mt-[12vh] max-[1024px]:mt-[14vh] max-[768px]:mt-[18vh] max-[480px]:mt-[20vh]
                        text-center
                    "
                >
                      {translation.about_us || "Sobre Nós"}
                    <span
                        className="
                            absolute bottom-[-1px] left-[-55%] w-[200%] h-[45px]
                            bg-gradient-to-r from-[rgba(106,13,173,0.4)] to-[rgba(255,102,178,0.4)]
                            shadow-[5px_5px_10px_rgba(0,0,0,0.2)] -z-20 rounded-[50px]
                        "
                        aria-hidden="true"
                    />
                </h2>
            </div>

            <div className="flex flex-wrap gap-8 p-8 bg-[#f6caef] justify-center">
                <div className="flex-1 basis-[calc(33.333%-2rem)] max-w-[600px] min-w-[280px] bg-none p-4 box-border text-left">
                    <h3 className="text-[#6c757d] text-[1.5rem] uppercase mb-4 font-bold">{translation.project_info_tittle}</h3>
                    <p className="text-[#003366] text-[1.1rem] font-bold mb-2">{translation.project_info}</p>
                </div>

                <div className="flex-1 basis-[calc(33.333%-2rem)] max-w-[600px] min-w-[280px] bg-none p-4 box-border text-left">
                    <h3 className="text-[#6c757d] text-[1.5rem] uppercase mb-4 font-bold">{translation.project_simple_tittle}</h3>
                    <p className="text-[#003366] text-[1.1rem] font-bold mb-2">{translation.project_simple}</p>
                </div>

                <div className="flex-1 basis-[calc(33.333%-2rem)] max-w-[600px] min-w-[280px] bg-none p-4 box-border text-left">
                    <h3 className="text-[#6c757d] text-[1.5rem] uppercase mb-4 font-bold">{translation.context_tittle}</h3>
                    <p className="text-[#003366] text-[1.1rem] font-bold mb-2">{translation.context}</p>
                </div>

                <div className="flex-1 basis-[calc(33.333%-2rem)] max-w-[600px] min-w-[280px] bg-none p-4 box-border text-left">
                    <h3 className="text-[#6c757d] text-[1.5rem] uppercase mb-4 font-bold">{translation.challenges_tittle}</h3>
                    {Array.isArray(translation.challenges) ? (
                        <ul className="list-disc pl-6">
                            {translation.challenges.map((item, index) => (
                                <li key={index} className="text-[#003366] text-base leading-[1.4] font-bold">{item}</li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-[#003366] text-[1.1rem] font-bold mb-2">{translation.challenges}</p>
                    )}
                </div>

                <div className="flex-1 basis-[calc(33.333%-2rem)] max-w-[600px] min-w-[280px] bg-none p-4 box-border text-left">
                    <h3 className="text-[#6c757d] text-[1.5rem] uppercase mb-4 font-bold">{translation.actions_tittle}</h3>
                    <ul className="list-disc pl-6">
                        {translation.actions.map((item, index) => (
                            <li key={index} className="text-[#003366] text-base leading-[1.4] font-bold">{item}</li>
                        ))}
                    </ul>
                </div>

                <div className="flex-1 basis-[calc(33.333%-2rem)] max-w-[600px] min-w-[280px] bg-none p-4 box-border text-left">
                    <h3 className="text-[#6c757d] text-[1.5rem] uppercase mb-4 font-bold">{translation.expected_results_tittle}</h3>
                    <p className="text-[#003366] text-[1.1rem] font-bold mb-2">{translation.expected_results}</p>
                </div>

            </div>

            <FinalComponent/>
        </div>
    );
};

export default SobreNos;
